<p>
  Ако сте активирали опцията <strong>„Приемам ценови предложения“</strong> във вашите обяви с фиксирана цена, ще може
  да получавате оферти от потенциални купувачи.
</p>
<p>
  Всеки път, когато получите ново предложение, ще бъдете уведомени чрез системно известие. Предложенията за конкретна
  обява се преглеждат директно от <strong>страницата на самата обява</strong>.
</p>
<h6 class="mt-3">Възможни действия при получено предложение:</h6>
<ul>
  <li><strong>Приемане</strong> – ако предложената цена ви удовлетворява, може да приемете офертата. Сделката се счита
    за сключена и автоматично ще бъде отворен чат между вас и купувача.
  </li>
  <li><strong>Отказване</strong> – ако предложението не е подходящо, може да го отхвърлите.
  </li>
  <li><strong>Контрапредложение</strong> – имате възможност да направите насрещна оферта с различна сума, която ще бъде
    изпратена обратно към купувача.
  </li>
</ul>
<h6 class="mt-3">Срокове и ограничения:</h6>
<ul>
  <li>Всяко предложение е валидно <strong>72 часа</strong>, освен ако не бъде прието, отказано или заменено с
    контрапредложение.
  </li>
  <li>Контрапредложенията също са валидни <strong>72 часа</strong>. Ако купувачът не реагира в този срок, предложението
    изтича автоматично.
  </li>
  <li>По едно и също време може да бъде активно <strong>само едно предложение</strong> между конкретен купувач и обява.
  </li>
</ul>
<div class="alert alert-primary m-0">
  <strong>Съвет:</strong> Отговаряйте своевременно на предложенията – това показва ангажираност и увеличава шансовете за
  успешна сделка.
</div>
